import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { syncStatusFilterConfig } from 'modules/integrations/lib/DataCollection/filters'

export const useSyncStatusFilterConfig = () => {
  const { syncEnabled, isSyncRunning, capabilityMode } = usePrivateIntegrationsSyncContext()
  if (!syncEnabled || isSyncRunning) return null

  return syncStatusFilterConfig(capabilityMode)
}
